export const syncIndicatorHeight = 21;
export const syncIndicatorClassName = "SyncIndicator";

export enum SyncIndicatorStatus {
  syncing = "syncing",
  idle = "idle",
  success = "success",
}
